import 'prop-types';
import styled from 'styled-components';

var VisuallyHidden = styled.span.attrs(function (_ref) {
  var _ref$role = _ref.role,
      role = _ref$role === void 0 ? "presentation" : _ref$role;
  return {
    role: role
  };
}).withConfig({
  displayName: "VisuallyHidden",
  componentId: "sc-1ogxlsz-0"
})(["&&{border:0;clip:rect(0,0,0,0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;white-space:nowrap;width:1px;}"]);

export { VisuallyHidden };
